<template>
  <div>
    <label>เลือกสิ่งอำนวยความสะดวกภายในห้อง</label>
    <div class="container">
      <div class="row">
        <div class="col-sm-12" v-for="(fac, type) in facilities" :key="type">
          <div class="checkbox mt-1" @click="toggleFacility(fac)">
            <div>
              <i class="far fa-square" v-if="!isFacExist(fac)" />
              <i class="fas fa-check-square selected" v-else></i>
              &nbsp;<img
                v-if="fac.get('icon')"
                :src="fac.get('icon').url()"
                height="28"
              />
              {{ fac.get("name_th") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formFacility from "@/assets/dataset/facility";
import _ from "underscore";
export default {
  props: {
    facilities: Array,
    value: {
      default: () => [],
    },
    apartmentId: {},
    userId: {},
  },
  data() {
    return {
      formFacility: Object.assign({}, formFacility),
      newItem: "",
      isNewItemSaved: true,
      isSaving: false,
    };
  },
  methods: {
    toggleFacility(fac) {
      let isFound = _.find(this.value, (f) => {
        return f.id === fac.id;
      });
      if (!isFound) {
        this.value.push(fac);
        this.$emit("input", this.value);
      } else {
        this.$emit(
          "input",
          _.reject(this.value, (f) => {
            return f.id === fac.id;
          })
        );
      }
    },
    isFacExist(fac) {
      let result = _.findWhere(this.value, { id: fac.id });
      return result;
    },
    updateVal() {
      this.formFacility = Object.assign({}, formFacility);
      for (let type in this.value) {
        this.formFacility[type] = this.value[type];
      }
    },
    addNewItem() {
      this.isNewItemSaved = false;
      this.newItem = "";
    },
    async saveNewItem(nameTH) {
      this.isSaving = true;
      let RoomFeature = this.Parse.Object.extend("ApartmentRoomFeature");
      let rf = new RoomFeature();
      rf.set("name_th", nameTH);
      let acl = new this.Parse.ACL();
      if (this.apartmentId) {
        acl.setRoleWriteAccess(`Role_${this.apartmentId}`, true);
        acl.setRoleReadAccess(`Role_${this.apartmentId}`, true);
      } else if (this.userId) {
        acl.setWriteAccess(this.userId, true);
        acl.setReadAccess(this.userId, true);
      } else {
        acl.setPublicWriteAccess(false);
        acl.setPublicReadAccess(false);
      }
      rf.setACL(acl);
      let result = await rf.save();
      this.facilities.push(result);
      this.isSaving = false;
      this.isNewItemSaved = true;
      this.toggleFacility(this.facilities[this.facilities.length - 1]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";

.add-facility {
  margin: 0;
  padding: 0;
}

.add-facility-btn {
  width: 100%;
  margin: 0;
  padding: 0;
}

.facility-input {
  display: inline;
  margin-right: 5px;
}

.fp-selectable {
  cursor: pointer;
}

.checkbox {
  cursor: pointer;
}

.selected {
  color: $primary-color;
}

.add-btn {
  cursor: pointer;
  color: $primary-color;
  margin-left: 30px;
}
</style>
